







































































































import Vue from "vue";
import Component from "vue-class-component";
import ApiFactory from "@/api/ApiFactory";
import AlertService from "@/services/alert.service";
import {
  ChangeUserPasswordCommand,
  RequestPasswordChangeCommand
} from "@/api/AuthenticationApiClient";
import { config } from "@vue/test-utils";
import PasswordStrengthIndicator from "@/views/auth/PasswordStrengthIndicator.vue";
import { UserStore, LoadingSpinnerService } from "@/store";
import router, { ROUTES } from "@/router";

@Component({
  components: {
    PasswordStrengthIndicator
  }
})
export default class ResetPassword extends Vue {
  private alertService = new AlertService();
  private userId: string | undefined;
  private token: string | undefined;
  private username: string = "";
  private newPassword: string = "";
  private confirmPassword: string = "";
  private requestResetMode: boolean = false;

  $refs!: {
    passwordStrengthIndicator: PasswordStrengthIndicator;
  };

  created() {
    this.token = this.$route.params.token;
    this.userId = this.$route.params.userid;
    this.requestResetMode =
      this.token === undefined || this.userId === undefined;
  }

  async onClickReset(event: MouseEvent) {
    event.preventDefault();

    LoadingSpinnerService.Show("Requesting password reset...");
    const apiClient = ApiFactory.CreateAuthClient();

    var cmd = new RequestPasswordChangeCommand({
      email: this.username,
      companyName: UserStore.companyName
    });

    try {
      const result = await apiClient.users_RequestPasswordChange(cmd);
      if (result) {
        if (result.success) {
          LoadingSpinnerService.Success(
            "Check your email inbox further instructions."
          );
          router.push({ name: ROUTES.home });
        } else {
          LoadingSpinnerService.Failure(
            "Unable to reset password. Please contact sender to confirm the status of your account."
          );
        }
      } else {
        throw new Error();
      }
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Unable to reset password. Please try again."
      );
    }
  }

  async onConfirmClicked(event: MouseEvent) {
    event.preventDefault();

    LoadingSpinnerService.Show("Creating new password...");
    const apiClient = ApiFactory.CreateAuthClient();

    var cmd = new ChangeUserPasswordCommand({
      userId: this.userId,
      token: this.token,
      password: this.newPassword
    });

    try {
      await apiClient.users_RecoverPassword(cmd);
      LoadingSpinnerService.Success("Password successfully changed.");
      router.push({ name: ROUTES.home });
    } catch (e) {
      LoadingSpinnerService.Failure(
        "Unable to reset password. Please try again."
      );
    }
  }

  showValidationError(): boolean {
    return (
      this.newPassword.length > 0 &&
      this.confirmPassword.length > 0 &&
      !this.passwordsMatch()
    );
  }

  passwordsMatch(): boolean {
    if (this.newPassword === "") return false;
    else return this.newPassword === this.confirmPassword;
  }

  passwordIsValid(): boolean {
    const isValid = this.$refs.passwordStrengthIndicator
      ? this.$refs.passwordStrengthIndicator.IsValid
      : false;
    return isValid && this.passwordsMatch();
  }
}
